import axios from 'axios'

export default async function syncProductionArticle(id: number) {
  return axios.post(`/api/v1/article/sync-production/${id}`)
}
